import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, CheckCircle2Icon } from 'lucide-react';
const NAMES = ['Martina', 'Sofía', 'Lucas', 'Valentina', 'Carla', 'María', 'Lucía', 'Justina', 'Laura', 'Juan', 'Pedro', 'Ana', 'Camila', 'Florencia'];
const CITIES = ['Córdoba', 'Buenos Aires', 'Rosario', 'Mendoza', 'Salta', 'Tucumán', 'La Plata', 'Mar del Plata', 'Santa Fe'];
const TIMES = ['hace 3 minutos', 'hace 5 minutos', 'hace 8 minutos', 'hace 10 minutos', 'hace 12 minutos', 'hace 15 minutos'];
const getRandomInt = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    time: ''
  });
  const lastNameRef = useRef('');
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    const showPopup = () => {
      // Ensure no consecutive repeats for the name
      let newName = NAMES[Math.floor(Math.random() * NAMES.length)];
      while (newName === lastNameRef.current) {
        newName = NAMES[Math.floor(Math.random() * NAMES.length)];
      }
      lastNameRef.current = newName;
      setData({
        name: newName,
        city: CITIES[Math.floor(Math.random() * CITIES.length)],
        time: TIMES[Math.floor(Math.random() * TIMES.length)]
      });
      setIsVisible(true);
      // Hide after 4-5 seconds
      timeoutId = setTimeout(() => {
        setIsVisible(false);
        // Schedule next appearance after 10-12 seconds
        timeoutId = setTimeout(showPopup, getRandomInt(10000, 12000));
      }, getRandomInt(4000, 5000));
    };
    // Initial delay of 10-12 seconds
    timeoutId = setTimeout(showPopup, getRandomInt(10000, 12000));
    return () => clearTimeout(timeoutId);
  }, []);
  return <AnimatePresence data-id="element-302">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20,
      transition: {
        duration: 0.4,
        ease: 'easeIn'
      }
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-50 w-[calc(100%-2rem)] max-w-[340px]" data-id="element-303">
          <div className="bg-[#f0ebe1] border-l-4 border-[#6b7c45] rounded-xl shadow-lg p-3.5 pr-8 flex items-center gap-3.5 relative" data-id="element-304">
            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Cerrar notificación" data-id="element-305">
              <XIcon className="w-4 h-4" data-id="element-306" />
            </button>

            <img src="https://cdn.magicpatterns.com/uploads/2NVmaC35Zzk7PgFh6E9FEV/IMG_3648_(1).png" alt="Ebook Nutrición Canina Fácil" className="w-[60px] h-[60px] rounded-md object-cover shadow-sm flex-shrink-0 bg-white" data-id="element-307" />

            <div className="flex-1 flex flex-col justify-center" data-id="element-308">
              <p className="text-sm font-bold text-gray-800 leading-tight" data-id="element-309">
                {data.name} de {data.city}
              </p>
              <p className="text-xs text-gray-600 mt-0.5 leading-tight" data-id="element-310">
                Compró recientemente el ebook
              </p>
              <p className="text-xs font-bold text-gray-800 mt-0.5 leading-tight" data-id="element-311">
                NUTRICIÓN CANINA FÁCIL
              </p>
              <div className="flex items-center gap-1.5 mt-1.5 text-[11px]" data-id="element-312">
                <span className="text-gray-500" data-id="element-313">{data.time}</span>
                <span className="text-gray-400" data-id="element-314">·</span>
                <span className="flex items-center gap-0.5 text-[#6b7c45] font-semibold" data-id="element-315">
                  <CheckCircle2Icon className="w-3.5 h-3.5" data-id="element-316" />
                  Verificado
                </span>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}